module.exports = __webpack_public_path__ + "img/e4_img1.653c222.jpg";